import React, { useState, useContext} from 'react'

const AppContext = React.createContext()

const AppProvider = ({ children }) => {

    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [play, setPlay] = useState(false);
    const [amount, setAmount] = useState(5);

    
    return (
        <AppContext.Provider
            value={{ images, setImages, loading, setLoading, play, setPlay, amount, setAmount}}
        >
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext)
}
  

export { AppContext, AppProvider }